import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Constants } from '../../utilities/Constants';
import { selectSaveAsTemplateToggledOn } from '../../../create-request/reducers';
import { selectCreateWireTemplateCallSuccessful } from '../../../account-info-header/reducers';

@Component({
  standalone: false,
  selector: 'mm-confirm-pend-reason',
  templateUrl: './confirm-pend-reason.component.html',
  styleUrls: ['./confirm-pend-reason.component.scss']
})
export class ConfirmPendReasonComponent implements OnInit {
  @Input() pendReasonDescription: string | null;
  @Input() useIcon: 'success' | 'warning' | null;
  isCreateWireTemplate$: Observable<boolean>;
  createTemplateCallSuccess$: Observable<boolean>;
  wireTemplateCopy: string = Constants.wireTemplateConfirmationText;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.isCreateWireTemplate$ = this.store.select(selectSaveAsTemplateToggledOn);
    this.createTemplateCallSuccess$ = this.store.select(selectCreateWireTemplateCallSuccessful);
  }

}
